import React from "react";
import { useStoreStatus } from "@/context/StoreContext";

export default function TodayHours() {
  const { status } = useStoreStatus();
  if (!status) return null;
  const t = status.today;
  return (
    <p data-testid="footer-today-hours">
      <span className="font-black text-biga-cream tracking-wide">Today ({t.day}):</span>{" "}
      {t.closed ? `Closed${t.note ? ` — ${t.note}` : ""}` : t.sessions.map((s) => `${s.label} ${s.start}–${s.end}`).join(" · ")}
      <span className="block text-biga-cream/50 text-xs">All times IST</span>
    </p>
  );
}
